import { FormAction } from '@anytag/shared-types';
import { SingleMonthPickerField } from '@anytag/shared-molecules';
import { useQueryHelper, useToggleState } from '@anytag/shared-hooks';
import { useExportCmsInvoiceToSpreadsheetMutation } from '@anytag/graphql';
import { BaseModal, DownloadButton, Form, ModalBody, ModalFooter } from '@anytag/shared-atoms';
import { useYoutubeCMSInvoicesFilter } from '../YoutubeCMSInvoicesFilter';

interface ExportFormValues {
  month: string;
}

interface ExportButtonProps {
  hasNoData?: boolean;
}

export const ExportButton = ({ hasNoData }: ExportButtonProps) => {
  const modal = useToggleState();
  const { filter } = useYoutubeCMSInvoicesFilter();
  const { t, enqueueSnackbar } = useQueryHelper();
  const { loading, callExportCmsInvoiceToSpreadsheet } = useExportCmsInvoiceToSpreadsheetMutation();

  const handleExport: FormAction<ExportFormValues>['onSubmit'] = async ({ month }) => {
    try {
      await callExportCmsInvoiceToSpreadsheet({ variables: { input: { month } } });
      enqueueSnackbar(t('succeededInRequest'), { variant: 'success' });
      modal.close();
    } catch (error) {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  };

  return (
    <>
      <DownloadButton onClick={modal.open} disabled={hasNoData} title={t('Button.Export')} className="mr-2 min-w-0" />

      <BaseModal open={modal.status} onClose={modal.close} title={t('Invoice Export')} asChild>
        <Form.Provider<ExportFormValues> defaultValues={{ month: filter.month }} onSubmit={handleExport}>
          {({ values }) => (
            <>
              <ModalBody>
                <SingleMonthPickerField name="month" clearable={false} title={t('Select Month')} />
              </ModalBody>

              <ModalFooter
                cancelButton={{ onClick: modal.close }}
                submitButton={{
                  type: 'submit',
                  disabled: !values.month,
                  title: t('Button.Export'),
                  loading: { status: loading, showIcon: true }
                }}
              />
            </>
          )}
        </Form.Provider>
      </BaseModal>
    </>
  );
};
